import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CostMgmtComponent} from 'src/app/main/cost-mgmt/cost-mgmt.component';

const routes: Routes = [
  {
    path: '',
    component: CostMgmtComponent,
    children: [{
      path: '',
      loadChildren: () => import('src/app/main/cost-mgmt/cost-details/cost-details.module').then(m => m.CostDetailsModule)
    },
      {
        path: ':tenantId',
        loadChildren: () => import('src/app/main/cost-mgmt/tenant-cost-details/tenant-cost-details.module').then(m => m.TenantCostDetailsModule)
      }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CostMgmtRoutingModule {
}
